// Íconos que se pueden poner en la tarjeta "Promo de hoy".
// Para agregar uno nuevo basta con sumarlo aquí: aparece en el panel y en la página.
export const PROMO_ITEMS = {
  pizza: { label: "Pizza", img: "/assets/imgs/pizza-pepperoni.webp" },
  papas: { label: "Papas", img: "https://images.unsplash.com/photo-1541592106381-b31e9677c0e5?w=900&q=80" },
  alitas: { label: "Alitas", img: "https://images.unsplash.com/photo-1567620832903-9fc6debc209f?w=900&q=80" },
  aros: { label: "Aros de cebolla", img: "https://images.unsplash.com/photo-1639024471283-03518883512d?w=900&q=80" },
  refresco: { label: "Refresco 2L", img: "https://images.unsplash.com/photo-1581636625402-29b2a704ef13?w=900&q=80" },
};
